
// Stripe Service for handling subscriptions and payments

// CONFIGURATION: Replace these with your actual Stripe Payment Link URLs from your Stripe Dashboard
// Go to Stripe > Payments > Payment Links > Create New
const STRIPE_CONFIG = {
    test: {
        monthly: 'https://buy.stripe.com/test_monthly_link_id',
        annual: 'https://buy.stripe.com/test_annual_link_id',
    },
    live: {
        monthly: 'https://buy.stripe.com/live_monthly_link_id', 
        annual: 'https://buy.stripe.com/live_annual_link_id',
    }
};

// Set this to 'live' when you are ready to accept real money
const MODE: 'test' | 'live' = 'test'; 

export const handleCheckout = (plan: 'monthly' | 'annual') => {
    try {
        const links = STRIPE_CONFIG[MODE];
        const url = links[plan];
        
        // Safety check for placeholder links in the demo version
        if (url.includes('link_id')) {
            alert("🚀 DEMO MODE ACTIVE\n\nIn a production environment, this button would redirect to your secure Stripe Checkout page.\n\nTo configure: Update 'STRIPE_CONFIG' in 'services/stripeService.ts' with your real Stripe Payment Links.");
            return;
        }

        if (url && url.startsWith('https')) {
            // Redirect the user to the secure Stripe hosted checkout page
            window.location.href = url;
        } else {
            console.error(`Stripe Configuration Error: No ${MODE} link found for plan: ${plan}`);
            alert("Payment system is currently in maintenance mode. Please try again later.");
        }
    } catch (error) {
        console.error("Checkout redirection failed", error);
        alert("Unable to redirect to payment provider.");
    }
};

export const getPlanDetails = (plan: 'monthly' | 'annual') => {
    return plan === 'monthly' 
        ? { price: '$9.99', interval: 'mo', label: 'Pro Monthly', savings: '' }
        : { price: '$89.99', interval: 'yr', label: 'Pro Annual', savings: 'Save 25%' };
};
